
import { connect } from 'react-redux';
import { actionCreators } from './actions';
import { LossPotentialEvaluationTileViewProps } from 'app/area/case/components/loss-potential/loss-potential-evaluation-tile-view';
import { AddRiskEvaluationInitialValues } from 'app/area/case/features/loss-potential-evaluation/types';
import { safeNumericString } from 'app/infrastructure/data/sanitize';

export const withCopyRiskEvaluation = () => (component: any, uiEngineProps: any) => {
  const dispatchToProps = (dispatch: any): Partial<LossPotentialEvaluationTileViewProps> => {

    return {
      onCopyRiskEvaluation: (riskMatrixInstance: number, instanceCopyCmd: number, initialValues: AddRiskEvaluationInitialValues, 
        copyToResidual: boolean = false) =>
        dispatch(actionCreators.copyRiskEvaluation(uiEngineProps, riskMatrixInstance, instanceCopyCmd, initialValues, copyToResidual))
    };
  };

  return connect<any, any, any>(null, dispatchToProps)(component);
};

export const withGetUiDefinition = (component: any, uiEngineProps: any) => {
  const dispatchToProps = (dispatch: any): Partial<LossPotentialEvaluationTileViewProps> => {
  const caseContextId: number = uiEngineProps?.router?.location?.query && 
    safeNumericString(uiEngineProps?.router.location.query.caseContextId) ||
    uiEngineProps?.entities?.[uiEngineProps.caseNumber]?.filter(r=>r?.caseContext)[0]?.caseContext[0]?.value || 
    uiEngineProps?.editing?.values?.filter(r=>r?.caseContext)[0]?.caseContext[0]?.value || 0;
    
    return {
      getUiDefinition: () =>
        dispatch(actionCreators.getUiDefinition(uiEngineProps.applicationId, caseContextId))
    };
  };

  return connect<any, any, any>(null, dispatchToProps)(component);
};
